import { Box, Icon, Stack, Text } from "@chakra-ui/react";
import { PaginationItem } from "./PaginationItem";
import ReactPaginate from "react-paginate";
import styled from 'styled-components';
import {FiChevronRight, FiChevronLeft} from 'react-icons/fi';
const StyledReactPaginate = styled(ReactPaginate).attrs({
  // You can redifine classes here, if you want.
  activeClassName: 'active', // default to "disabled"
})`
  margin-top:20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  list-style-type: none;
  height:40px;

  li {
    margin-right: 5px
  }
  li a {
    border-radius: 7px;
    padding-top: 10px;
    padding-left: 12px;
    padding-bottom: 10px;
    padding-right: 12px;
    cursor: pointer;
    color: white;
  }
  li.previous a,
  li.next a,
  li.break a {
    border-color: transparent;
  }
  li.active a {
    background-color: #00ff12;
    border-color: transparent;
    color: white;
    min-width: 32px;
  }
  li.disabled a {
    color: grey;
  }
  li.disable,
  li.disabled a {
    cursor: default;
  }
`;

interface IParams {
  total: number,
  totalPerPage: number,
  onChange: (pageNumber: number) => void
}

export function Pagination({ total, totalPerPage, onChange }:IParams) {
 const pageCount = Math.ceil(total / totalPerPage);
 
  return (
    <StyledReactPaginate 
      pageCount={pageCount} 
      onPageChange={(data: { selected:number }) =>  onChange(data.selected +1)} 
      previousLabel={<Icon as={FiChevronLeft} fontSize="20" color="white" />} 
      nextLabel={<Icon as={FiChevronRight} fontSize="20" color="white" />}
    />
  );
}
//